import zmFormula from './zmFormulaHelperService'
import util from "zmfront-framework/src/utils/util";
import zmRemoteFee from "./zmQueryRemoteFeeService";

const zmPackingFee = {};
//
zmPackingFee.facade={};
//包装费查询参数
zmPackingFee.param={
    actual:0,
    length:0,
    height:0,
    width:0,
    weig:0,
    yes:1,
};
//包装费
zmPackingFee.bo={};

zmPackingFee.getResult= function (param){
    zmFormula.zmformulahelper(param.formula);
    zmFormula.setParam("@act",zmPackingFee.param.actual);
    zmFormula.setParam("@len",zmPackingFee.param.length);
    zmFormula.setParam("@hei",zmPackingFee.param.height);

    if(!param.vol){
        param.vol=0;
    }
    if(!param.chargeVolume){
        param.chargeVolume=0;
    }
    if(!param.length || !param.height || !param.width || param.length==0 || param.height==0 || param.width==0){
        param.chargeVolume=0;
    }else{
        var chargeVolume= ((param.length*param.height*param.width)/1000000).toFixed(3);
        param.chargeVolume=chargeVolume*1;
    }
    zmFormula.setParam("@vol",param.vol);
    zmFormula.setParam("@cub",param.chargeVolume);
    zmFormula.setParam("@wid",zmPackingFee.param.width);
    zmFormula.setParam("@yes",param.yes);
    // zmFormula.setParam("@no",-1);
    zmFormula.setParam("@wei",zmPackingFee.param.weig);
    //返回是否执行成功
    return zmFormula.evalOfBigDecimal();
};

/*
*去重
* */
zmPackingFee.uniq = function(array){
    var temp = []; //一个新的临时数组
    for(var i = 0; i < array.length; i++){
        if(temp.indexOf(array[i]) == -1){
            temp.push(array[i]);
        }
    }
    return temp;
};
//排序  按  长 宽 高  第一长是长  第二是宽  第三是高
zmPackingFee.sortParam=function(param){
    var temp = []; //一个新的临时数组
    temp.push(param.length);
    temp.push(param.height);
    temp.push(param.width);
    temp.sort(function(a,b){
        return  a-b;
    });
    zmPackingFee.param=param;
    zmPackingFee.param.length=temp[temp.length-1];
    zmPackingFee.param.width=temp[temp.length-2];
    zmPackingFee.param.height=temp[temp.length-3];
};

//包装费用计算
zmPackingFee.call= function (param){
    //返回最初状态
    zmPackingFee.facade={};
    zmPackingFee.param={
        actual:0,
        length:0,
        height:0,
        width:0,
        weig:0,
        yes:1,
    };
    zmPackingFee.bo={};
    zmRemoteFee.dateFeeCaChe();
    if(param.length==null ||  param.height==null || param.width==null){
        return zmPackingFee.bo;
    }
    zmPackingFee.sortParam(param);
    let packingfee={};
    let packingfeeList=zmRemoteFee.getCacheRefresh("packing");

    for(var j=0;j<packingfeeList.length;j++){
        let hubinIds=packingfeeList[j].hubinIds;
        if(hubinIds!=null && hubinIds!=undefined && hubinIds!=''){
            if(hubinIds.indexOf(",")!=-1){
                var str= hubinIds.split(',');
                for(var i=0;i<str.length;i++){
                    if(str[i]==param.hubInId){
                        packingfee=packingfeeList[j];
                        break;
                    }
                }
            }else{
                if(packingfeeList[j].hubinIds==param.hubInId){
                    packingfee=packingfeeList[j];
                    break;
                }
            }
        }
    }
    if(!packingfee || packingfee==null || packingfee==undefined || packingfee=='' || packingfee.id<=0 || JSON.stringify(packingfee) == "{}") {
        for (var j = 0; j < packingfeeList.length; j++) {
            let types = packingfeeList[j].hubinTypes;
            if (types.indexOf(",") != -1) {
                var str = types.split(',');
                for (var i = 0; i < str.length; i++) {
                    if (str[i] == param.hubinType) {
                        packingfee = packingfeeList[j];
                        break;
                    }
                }
            } else {
                if (packingfeeList[j].hubinTypes == param.hubinType) {
                    packingfee = packingfeeList[j];
                    break;
                }
            }
        }
    }
    // 1. 规则找不到，返回零
    if(packingfee==null || packingfee==undefined || packingfee=='' || packingfee.id<=0 || JSON.stringify(packingfee) == "{}"){
        zmPackingFee.bo.fee=0;
        zmPackingFee.bo.currency=param.currency;
        zmPackingFee.bo.formula='';
        return zmPackingFee.bo;
    }
    // 2. 到付包装费,返回零
    if(parseInt(packingfee.isDestpay)==0 && param.ccPayment.toUpperCase()=='CC'){
        zmPackingFee.bo.fee=0;
        zmPackingFee.bo.currency=param.currency;
        zmPackingFee.bo.formula='';
        return zmPackingFee.bo;
    }
    var currency= packingfee.currency==null ? param.currency : packingfee.currency;
    let excehs = zmRemoteFee.getExch({custId:param.custId,change:1000,cur:currency});
    //获取包装费
    let arr=zmRemoteFee.getCacheRefresh("packingOpt");
    let optsList=[];
    for(var i=0;i<arr.length;i++) {
        if (arr != null && arr[i].packingfeeId==packingfee.id) {
            optsList.push(arr[i]);
        }
    }
    // 3. 包装费找不到，返回零
    if(optsList==null || optsList==undefined || optsList.length<=0){
        zmPackingFee.bo.fee=0;
        zmPackingFee.bo.currency=param.currency;
        zmPackingFee.bo.formula='';
        return zmPackingFee.bo;
    }
    // 4. 按类型从小到大排序； 1:不收项目2:附加手续服务费3:超过最大限制附加费
    for(var i=0;i<optsList.length-1;i++){
        for(var j=0;j<optsList.length-i-1;j++){
            if(optsList[j].optionType>optsList[j+1].optionType){
                var hand = optsList[j];
                optsList[j]=optsList[j+1];
                optsList[j+1]=hand;
            }
        }
    }
    let minweig= 0;
    let isToall=0;
    let feeNames = "" ;
    let remark = "";
    let finalFee=0;
    let formula="";
    let opt={};
    let isAdd=false;
    let map=[];
    let array=[];
    for(var i=0;i<optsList.length;i++) {
        isAdd=false;
        opt=optsList[i];
        opt.yes=optsList[i].fee;

        // 判断是拒收 类型
        if(opt.optionType==1){
            opt.yes=1;
            //当前指定路线不允许收取此包裹
            if(zmPackingFee.getResult(opt)>0){
                zmPackingFee.bo.fee=-1;
                zmPackingFee.bo.currency=param.currency;
                zmPackingFee.bo.remark=opt.remark;
                zmPackingFee.bo.feeNames=opt.optionName;
                zmPackingFee.bo.packProject=opt.optionName;
                zmPackingFee.bo.formula='';
                return zmPackingFee.bo;
            }
        }else{
            opt.yes=1;
            //4.1按类型除不收项目外，其余只取最大值
            if(zmPackingFee.getResult(opt)>0){
                array.push(opt.optionType);
                opt.yes=optsList[i].fee;
                opt.charge=zmPackingFee.getResult(opt);
                // 4. 加收燃油费;
                if (opt.isAddfuel && opt.isAddfuel == 1) {
                    let quoteFuelList= zmRemoteFee.getCacheRefresh("quotefuel");
                    let quoteFuel={};
                    if(quoteFuelList){
                        console.log(quoteFuelList);
                        for(var is=0;is<quoteFuelList.length;is++){
                            let hubinIds=quoteFuelList[is].hubIdList;
                            if(hubinIds!=null && hubinIds!=undefined && hubinIds!='' && hubinIds.length>0){
                                for(var k=0;k<hubinIds.length;k++){
                                    if(hubinIds[k]==param.hubInId){
                                        quoteFuel=quoteFuelList[is];
                                        break;
                                    }
                                }
                            }
                        }
                        //判断是否取到值  根据路线id
                        if(!quoteFuel || quoteFuel==null || quoteFuel==undefined || quoteFuel=='' || quoteFuel.id<=0 || JSON.stringify(quoteFuel) == "{}") {
                            for(var is=0;is<quoteFuelList.length;is++){
                                //4.2去自己创建的数据
                                if(quoteFuelList[is].hubType==param.hubinType && quoteFuelList[is].ardedNo=='01'){
                                    quoteFuel=quoteFuelList[is];
                                    break;
                                }
                            }
                        }
                        //判断是否取值到燃油费用
                        if (null != quoteFuel && quoteFuel != undefined && quoteFuel.fuelRate !=null) {
                            opt.charge = opt.charge*(1+(quoteFuel.fuelRate));
                        }
                    }
                }
                //判断取最大金额
                if((!opt.charge) && opt.charge>0 && opt.charge<opt.fee){
                    opt.charge=opt.fee;
                }
                map.push(opt);
            }
        }
    }
    if(map && map.length>0){
        var list = new Array();
        var strs=new Array();
        //去重
        array= zmPackingFee.uniq(array);
        for(var j=0;j<array.length;j++){
            var maxcnt=0;
            var weigs=0;
            var isToalls=0;
            for(var k=0;k<map.length;k++){
                if(map[k].optionType==array[j]){
                    // list.push(map[k].charge);
                    if(map[k].charge!=null && map[k].charge>=0 && maxcnt<=map[k].charge){
                        maxcnt=map[k].charge;
                        isToalls = map[k].isToall;
                        weigs=map[k];
                    }
                }
            }
            list.push(weigs);
            strs.push(isToalls);
            finalFee = finalFee+maxcnt;
            formula= formula+maxcnt;
            for(var k=0;k<map.length;k++){
                if(map[k].optionType==array[j] && map[k].charge==maxcnt){
                    feeNames = feeNames+map[k].optionName+",";
                    remark = remark+ map[k].remark+",";
                }
            }
        }
        if(list && list.length>0){
            if(list.length==1){
                minweig=list[0].minWeig;
                isToall=list[0].isToall;
            }else{
                for(var l=0;l<list.length;l++){
                    var ings=list[l].minWeig;
                    if(ings && ings>minweig){
                        minweig=ings;
                        isToall=list[l].isToall;
                    }
                }
            }
        }
        feeNames = feeNames.substring(0,feeNames.length-1);
        remark =  remark.substring(0,remark.length-1);
    }
    if(packingfee.isExchangeSwap!=null && packingfee.isExchangeSwap!=undefined && packingfee.isExchangeSwap!="" && packingfee.isExchangeSwap==1){
        finalFee=finalFee*excehs.exch;
        formula="("+formula+")*"+excehs.exch;
        zmPackingFee.bo.currency=excehs.cur;
    }else{
        zmPackingFee.bo.currency=packingfee.currency==null ? param.currency : packingfee.currency;
    }
    zmPackingFee.bo.fee=finalFee.toFixed(2);
    zmPackingFee.bo.formula=formula;
    zmPackingFee.bo.feeNames=feeNames;
    zmPackingFee.bo.packProject=feeNames;
    zmPackingFee.bo.packRemark=remark;
    zmPackingFee.bo.maxWeig=0;
    //zmPackingFee.bo.currency=optsList[0].currency==null ? param.currency : optsList[0].currency;
    zmPackingFee.bo.feeType=packingfee.feeType;
    if(feeNames){
        zmPackingFee.bo.minWeig=minweig;
        if(isToall>0){
            zmPackingFee.bo.isToall=isToall;
        }
    }
    console.log(zmPackingFee.bo);
    return zmPackingFee.bo;
};



export default zmPackingFee;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmPackingFeeService.js